import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate(nextUrl?: string): boolean | Observable<boolean> | Promise<boolean>;
}

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component, _currentRoute, _currentState, nextState
) => {
  return component?.canDeactivate ? component.canDeactivate(nextState?.url) : true;
};
